import { render, staticRenderFns } from "./DestroyConfirmer.vue?vue&type=template&id=7f2d0442"
import script from "./DestroyConfirmer.vue?vue&type=script&lang=js"
export * from "./DestroyConfirmer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports